import ReactDOM from 'react-dom';
import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var SurveyPromptConfig = require("lib/survey/SurveyPromptConfig.js");
var SurveyPromptDisplay = require("components/survey/SurveyPromptDisplay.js")

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

@connect(
  (state, props) => ({
    prompts: RosterSelectors.admin({ state, id: CurrentUser.get().id }) ? RosterSelectors.admin({ state, id: CurrentUser.get().id }).survey_prompts : []
  }),
  (dispatch, props) => ({
    fetchAdmin: function () {
      dispatch(RosterActions.fetchAdmins({
        filters: { ids: [CurrentUser.get().id] },
        embeds: ['admin.survey_prompts'],
      }))
    }
  })
)

class SurveyPromptUtility extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = { prompt: null }
  }

  async start() {
    var prompt = await this.selectPrompt()
    if (prompt) {
      this.observe()
    }
  }

  // selects random prompt
  selectPrompt() {
    return new Promise(resolve => {
      // Get saved data from sessionStorage
      var existingPromptID = parseInt(sessionStorage.getItem(SurveyPromptConfig.PROMPT_SESSION_KEY));

      var possiblePromptIDs = _.map(this.props.prompts, 'id')

      if (existingPromptID && _.include(possiblePromptIDs, existingPromptID)) {
        var prompt = _.find(this.props.prompts, { id: existingPromptID })
        // for LO
        console.log('prompt:', prompt)
      } else {
        var prompt = this.props.prompts[Math.floor(Math.random() * this.props.prompts.length)];
        if (prompt.id) {
          // for LO
          console.log('prompt:', prompt)
          sessionStorage.setItem(SurveyPromptConfig.PROMPT_SESSION_KEY, prompt.id);
        }
      }
      if (prompt && this.validKey(prompt) && this.promptTriggerLocation(SurveyPromptConfig.CONFIG[prompt.key])) {
        var prompt = _.extend(SurveyPromptConfig.CONFIG[prompt.key], prompt)
        prompt.options = prompt.options.split('|')
        this.setState({ prompt: prompt }, resolve(prompt))
      }
    });
  }

  // checks if user is on prompt's key is in config file
  validKey(prompt) {
    return _.includes(SurveyPromptConfig.VALID_KEYS, prompt.key)
  }

  // checks if user is on prompt's target location
  promptTriggerLocation(promptConfig) {
    if (_.includes(promptConfig.trigger.paths, 'home') && window.location.pathname == '/') {
      return true
    } else {
      return promptConfig.trigger.paths.every(str => window.location.pathname.includes(str))
    }
  }

  excludedClassesPresent(prompt, el) {
    var excludedElements = _.compact(_.map(prompt.trigger.exclude_classes, exClass => {
      return $(el).hasClass(exClass.replace('.', ''))
    }))

    return _.size(excludedElements) > 0
  }

  getAnchors(anchor, excludedClasses) {
    var stippedAnchor = anchor.replace('.', '').replace('#', '')

    if ($(document.getElementsByClassName(stippedAnchor)).length > 0) {
      return $(document.getElementsByClassName(stippedAnchor))
    }
    else if (document.getElementById(stippedAnchor)) {
      return [document.getElementById(stippedAnchor)]
    }
    else {
      return []
    }
  }

  // Every time a class changes down the DOM, determine if it needs a survey
  observe() {
    var { prompt } = this.state

    var observerElement = document.querySelector(this.props.watchContainer)

    var observer = new MutationObserver(() => {

      var anchors = this.getAnchors(prompt.trigger.class)
      if (anchors.length == 1 && !this.excludedClassesPresent(prompt, anchors)) {

        LuckyOrangeClient.tagComponent(`SurveyPrompt Shown: ${prompt.key}`);
        this.injectElement(anchors, prompt, 0, observer)

      } else if (anchors.length > 1) {

        LuckyOrangeClient.tagComponent(`SurveyPrompt Shown: ${prompt.key}`);
        anchors.each((i, el) => {
          if (!this.excludedClassesPresent(prompt, el)) {
            this.injectElement(el, prompt, i, observer)
          }
        })
      }
    })

    observer.observe(observerElement, { childList: true, subtree: true });
  }

  injectElement(el, prompt, i, observer) {
    var newClass = `surveyPromptContainer-${prompt.key}`
    // if the element doesn't already have a survey, create one
    var parent = $(el).closest(prompt.location.parent)
    if ($(parent).find(`.${newClass}`).length == 0) {

      // prevents infinite loop
      observer.disconnect()

      // find preceding element
      var anchor = $(parent).find(prompt.location.anchor)

      // create div for survey
      var newID = `${newClass}-${i}`
      $(`<div class="surveyPromptContainer ${newClass} ${prompt.style.class}" id="${newID}"></div>`).insertAfter(anchor)

      // attach extra data to send to backend
      var dataPacket = SurveyPromptConfig.getDataPacket(newID, prompt)

      // inject survey
      ReactDOM.render(<SurveyPromptDisplay onSubmitFeedback={this.props.fetchAdmin} prompt={prompt} userID={CurrentUser.get().id} dataPacket={dataPacket} />, document.getElementById(newID));

      // add additional styling if survey is contained within specific item
      if (prompt.location.absolute_anchor) {
        // style survey
        var pos = $(`${prompt.location.absolute_anchor}`).position()
        if ($(window).width() <= 500) {
          $(`#${newID}`).css({
            top: `calc(${pos.top}px + 100px)`,
            position: 'absolute',
            left: `60%`,
            bottom: `0px`,
            width: `40%`,
            float: 'unset'
          })
        } else {
          $(`#${newID}`).css({
            top: `calc(${pos.top}px + 100px)`,
            position: 'absolute',
            left: `80%`,
            bottom: `0px`,
            width: `20%`,
            float: 'unset'
          })
        }

        // style page to make survey animations work
        // REMOVE THIS WHEN SURVEYS ARE NOT RUNNING
        $(`#pageContent`).css({ 'position': 'relative', 'overflow-x': 'hidden' })
      }
    }
  }

  render() {
    return null
  }

  componentDidUpdate(prevProps) {
    if (_.size(this.props.prompts) && (prevProps.prompts !== this.props.prompts || prevProps.pathname !== this.props.pathname)) {
      // remove existing survey prompts
      $('.surveyPromptContainer').each((i, el) => {
        $(el).remove();
      })

      // remove possible added styling to parent div
      if ($('#pageContent').css('position') == 'relative') {
        $(`#pageContent`).css({ position: 'initial', 'overflow-x': 'initial' })
      }

      // start listening
      this.start()
    }
  }
}

module.exports = SurveyPromptUtility;





// WEBPACK FOOTER //
// ./modules/lib/survey/SurveyPromptUtility.js